export function isImageValid(url: string) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true); // 이미지 로드 성공 시
    img.onerror = () => resolve(false); // 이미지 로드 실패 시
    img.src = url; // 이미지 URL 설정
  });
}
